import { CriterioDesempatePregao, CriterioJulgamento, CriterioJulgamentoValor, FormatoLicitacao, SituacaoLicitacao, SituacaoPregao, TipoObjetoLicitacao, TipoPregao } from '../../components/types';
import { BaseResourceModel } from '../../models/base-resource.model';
import { Setor } from '../almoxarifado/setor.model';
import { Contrato } from '../compra/contrato.model';
import { Exercicio } from '../comum/exercicio.model';
import { Orgao } from '../comum/orgao.model';
import { Pessoa } from '../comum/pessoa.model';
import { Comissao } from './comissao.model';
import { LicitacaoAudesp } from './licitacao-audesp.model';
import { LicitacaoComissaoMembro } from './licitacao-comissao-membro.model';
import { LicitacaoFiscal } from './licitacao-fiscal.model';
import { Memorial } from './memorial.model';
import { Modalidade } from './modalidade.model';
import { PregaoHistorico } from './pregao-historico.model';
import { Proponente } from './proponente.model';
import { TipoContratacao } from './tipo-contratacao.model';

export class Licitacao extends BaseResourceModel {
  constructor(
    public id?: number,
    public formato_contratacao?: FormatoLicitacao,
    public justificativa?: string,
    public data_inicio?: Date,
    public data_termino?: Date,
    public prazo_pagamento?: number,
    public prazo_entrega?: number,
    public numero?: string,
    public sequencia?: number,
    public data_abertura?: Date,
    public data_ata?: Date,
    public data_edital?: Date,
    public data_julgamento?: Date,
    public data_parecer?: Date,
    public data_publicacao?: Date,
    public data_homologacao?: Date,
    public data_cancelamento?: Date,
    public data_assinatura?: Date,
    public data_ratificacao?: Date,
    public data_abertura_env?: Date,
    public data_entrega_env?: Date,
    public situacao?: SituacaoLicitacao,
    public situacao_pregao?: SituacaoPregao,
    public processo?: string,
    public objeto?: string,
    public valor_estimado?: number,
    public valor_licitado?: number,
    public enviar_transparencia?: boolean,
    public criterio_julgamento?: CriterioJulgamento,
    public criterio_julgamento_valor?: CriterioJulgamentoValor,
    public tipo_pregao?: TipoPregao,
    public criterio_desempate?: CriterioDesempatePregao,
    public fracassar_auto?: boolean,
    public modelo_ata?: string,
    public natureza?: number,
    public tipo_licitacao?: number,
    public objeto_licitacao?: number,
    public lei_1232006?: number,
    public tipo_objeto?: TipoObjetoLicitacao,
    public modalidade?: Modalidade,
    public orgao?: Orgao,
    public setor?: Setor,
    public exercicio?: Exercicio,
    public comissao?: Comissao,
    public tipo_contratacao?: TipoContratacao,
    public solicitante?: Pessoa,
    public processo_cc?: Licitacao,
    public licitacao_audesp?: LicitacaoAudesp,
    public itens?: Memorial[],
    public proponentes?: Proponente[],
    public fiscais?: LicitacaoFiscal[],
    public historicos?: PregaoHistorico[],
    public contratos?: Contrato[],
    public comissao_membros?: LicitacaoComissaoMembro[],
    public vencedores?: any,
    public selecionado?: boolean,
  ) {
    super();
  }
  static converteJson(json: any): Licitacao {
    return Object.assign(new Licitacao(), json);
  }
}
